import { motion } from 'motion/react'
import { UnicornScene } from 'unicornstudio-react'

import env from '~/env'
import { useFlag } from '~/hooks/useFlag'

import backupimg from './backup-auth.png'
import video from './deepinsight-auth-low.webm'

export const AuthBackdrop = () => {
    const isEnabled = useFlag('auth_page__use_unicorn_video')

    const reducedMotion = env.VITE_NO_UNSTABLE_EFFECTS

    if (reducedMotion) return <img src={backupimg} className="absolute inset-0 object-cover" />

    return isEnabled ? (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { duration: 1, delay: 0.5 } }}>
            <UnicornScene
                lazyLoad={true}
                production={true}
                projectId="a1ecRmKHrizVN5rrT0d4"
                dpi={1.5}
                fps={24}
                showPlaceholderOnError
                showPlaceholderWhileLoading
                placeholder={<img src={backupimg} className="absolute inset-0 object-cover" />}
                width="100vw"
                height="100dvh"
                className="absolute inset-0 object-cover"
            />
        </motion.div>
    ) : (
        <motion.video
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1, delay: 0.5 } }}
            className="absolute inset-0 h-full w-full object-cover"
            autoPlay
            muted
            loop
            playsInline
            data-test="auth-page-video"
        >
            <source src={video} type="video/webm" />
            <img src={backupimg} alt="Backup image for video" className="h-full w-full object-cover" />
        </motion.video>
    )
}
